export const CAMPAIGN_SUB_OFFER_CANCEL_SAVE_OFFER = 'cancel_save_offer';

export const EVENT_ACTION_AUTO_RENEW_OPT_IN = 'renewOptIn';
export const EVENT_ACTION_CANCEL_PAYWALL = 'cancel';
export const EVENT_ACTION_CANCEL_SUB = 'cancelSub';
export const EVENT_ACTION_DELETE_CARD = 'delete card';
export const EVENT_ACTION_DELETE_PAYPAL_ACCOUNT = 'delete paypal account';
export const EVENT_ACTION_MERCH_PAGE_CLICK = 'merchandising';
export const EVENT_ACTION_PURCHASE = 'purchase';
export const EVENT_ACTION_RENEWAL_DISABLED = 'renewalDisabled';
export const EVENT_ACTION_RENEWAL_ENABLED = 'renewalEnabled';
export const EVENT_ACTION_SAVE_PAYMENT_METHOD = 'savePaymentMethod';
export const EVENT_ACTION_START_PURCHASE = 'start purchase';
export const EVENT_ACTION_UPDATE_PAYMENT = 'updatePayment';
export const EVENT_ACTION_USE_DIFFERENT_CARD = 'useDifferentCard';
export const EVENT_ACTION_VIEW_PAYWALL = 'view';
export const EVENT_ACTION_VAULTING_STARTED = 'vaulting started';
export const EVENT_ACTION_VAULTING_SUCCESS = 'vaulting success';
export const EVENT_ACTION_VAULTING_FAILURE = 'vaulting failure';

export const ACTION_CONTEXT_BRAINTREE_EXCEPTION = 'braintree exception';
export const ACTION_CONTEXT_CANNOT_GET_DEVICE_FINGERPRINT = 'cannot get device fingerprint';
export const ACTION_CONTEXT_MISSING_NONCE_METADATA = 'missing nonce metadata';
export const ACTION_CONTEXT_SAVING_PAYMENT_EXCEPTION = 'saving payment exception';
export const ACTION_CONTEXT_USER_CANCELLED = 'user cancelled';
export const ACTION_CONTEXT_HTTP_ERROR = 'http error';
export const ACTION_CONTEXT_NETWORK_ERROR = 'network error';
export const ACTION_CONTEXT_EMPTY_BODY_EXCEPTION = 'empty body exception';
export const ACTION_CONTEXT_INELIGIBLE_PAYMENT = 'ineligible payment';
export const ACTION_CONTEXT_UNKNOWN_ERROR = 'unknown error';

export const EVENT_PRODUCT_TYPE_BOOST = 'boost';
export const EVENT_PRODUCT_TYPE_BOOST_SUBSCRIPTION = 'boost subscription';
export const EVENT_PRODUCT_TYPE_BOUNCER_BYPASS = 'alcBouncer';
export const EVENT_PRODUCT_TYPE_GOLD = 'gold';
export const EVENT_PRODUCT_TYPE_MY_BOOSTS = 'my_boosts';
export const EVENT_PRODUCT_TYPE_PLATINUM = 'platinum';
export const EVENT_PRODUCT_TYPE_PLUS = 'plus';
export const EVENT_PRODUCT_TYPE_PRIMETIME_BOOST = 'primetimeboost';
export const EVENT_PRODUCT_TYPE_READ_RECEIPTS = 'readReceipts';
export const EVENT_PRODUCT_TYPE_SUPERBOOST = 'superboost';
export const EVENT_PRODUCT_TYPE_SUPERLIKE = 'superlike';
export const EVENT_PRODUCT_TYPE_SELECT_SUBSCRIPTION = 'select_subscription';

export const FUNNEL_CHECKOUT_ERROR = 'CheckoutError';
export const FUNNEL_CHECKOUT_PAGE_ACTION = 'CheckoutPageAction';
export const FUNNEL_CHECKOUT_PAGE_VIEW = 'CheckoutPageView';

export const PAGE_VERSION_CHECKOUT = 'checkout';
export const PAGE_VERSION_CHECKOUT_SELECT_PAYMENT = 'checkoutSelectPayment';
export const PAGE_VERSION_PAYPAL = 'Paypal';
export const PAGE_VERSION_PAYPAL_VAULTING_SETTINGS = 'paypalVaultingSettings';
export const PAGE_VERSION_PAYPAL_VAULTING_CHECKOUT = 'paypalVaultingCheckout';

export const PAGE_TYPE_ADD_NEW_CARD = 'addNewCard';
export const PAGE_TYPE_ENTER_CARD = 'enterCard';
export const PAGE_TYPE_MANAGE_ACCOUNT = 'manageAccount';
export const PAGE_TYPE_ONE_CLICK = 'oneClick';
export const PAGE_TYPE_PAYPAL = 'Paypal';
export const PAGE_TYPE_UPDATE_CARD = 'updateCard';

// Note: these are for Analytics, do not confused with the platform under payment methods in the offerings
export const PURCHASE_METHOD_CC = 'creditCard';
export const PURCHASE_METHOD_PAYPAL = 'Paypal';

export const SOURCE_SESSION_EVENT_REVENUE = 'revenue';
export const SOURCE_SESSION_EVENT_SETTINGS = 'settings';

export const EVENT_TYPE_DISCOVERY_PREMIUM_PREFERENCE = 'discovery_premium_preference';
